module.exports = __webpack_public_path__ + "img/more.1c8b581.svg";